import React from 'react'

const Footer = () => {
  return (
    <div>
      made by---
    </div>
  )
}

export default Footer
